import { useEffect, useState } from "react";

import React from "react";
import { getResolveJSON } from "../../util/fetch";
import { getBaseURL } from "../../config/runtime";
import { SchemesData } from "../../domain/Scheme/data/schemes_data";
import { UserData } from "../../domain/user/user_data";
import { SchemeCard } from "./scheme_card";
import { SchemeData } from "../../domain/Scheme/data/scheme_data";
import styled from "styled-components";

export interface Props {
  user: UserData;
}

const Root = styled.div`
  background: #efefef;
  border-radius: 0.8rem;
  padding: 1rem;

  .card-scheme {
    margin-bottom: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const Header = styled.header`
  align-items: center;
  background: #fff;
  border-radius: 0.4rem;
  box-shadow: 0 0 0.2rem #cdcdcd;
  font-size: 1.1rem;
  font-weight: bold;
  letter-spacing: 0.02rem;
  margin-bottom: 1rem;
  padding: 0.5rem 1rem;
  text-align: center;
`;

export const SchemeCardDeck = (props: Props) => {
  const { user } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<SchemeData[]>([]);

  const fetchData = React.useCallback(async ({ userId }) => {
    setLoading(true);

    const schemes = await getResolveJSON<SchemesData>(
      getBaseURL() + `/v1/client/users/${userId}/schemes?expands=product`
    );

    setData(schemes.data);
    setLoading(false);
  }, []);

  useEffect(() => {
    if (user) {
      fetchData({ userId: user.id });
    }
  }, [user?.id]);

  const getContents = () => {
    if (user) {
      if (data.length === 0) {
        return (
          <Root>
            <Header className="card-scheme">
              {user.name_first} {user.name_last} has no saved homes
            </Header>
          </Root>
        );
      } else {
        return (
          <Root>
            <Header>
              {user.name_first} {user.name_last} saved homes
            </Header>
            {data.map((d) => (
              <SchemeCard key={d.id} data={d} />
            ))}
          </Root>
        );
      }
    }
    return null;
  };

  return getContents();
};
